import { useEffect, useState } from "react";
import {
  Button,
  Select,
  TimePicker,
  Space,
  Divider,
  message,
  Checkbox,
} from "antd";
import { ASIDeviceService } from "../../../ducks/asi-devices/asi-devices";

const asiDeviceService = new ASIDeviceService();
const DAYS = [
  { label: "Понедельник", value: "Monday" },
  { label: "Вторник", value: "Tuesday" },
  { label: "Среда", value: "Wednesday" },
  { label: "Четверг", value: "Thursday" },
  { label: "Пятница", value: "Friday" },
  { label: "Суббота", value: "Saturday" },
  { label: "Воскресенье", value: "Sunday" },
];

type ScheduleItem = {
  dayOfWeek: string;
  startTime: string;
  endTime: string;
};

export const AsiScheduleForm = ({
  asiId,
  schedule,
}: {
  asiId: string;
  schedule?: {
    openSchedule?: ScheduleItem[];
    scheduleEnabled?: boolean;
  };
}) => {
  const [schedules, setSchedules] = useState<ScheduleItem[]>([]);
  const [scheduleEnabled, setScheduleEnabled] = useState<boolean>(false);
  const [dayOfWeek, setDayOfWeek] = useState<string>();
  const [timeRange, setTimeRange] = useState<any>(null);

  useEffect(() => {
    if (schedule?.openSchedule?.length) {
      setSchedules(schedule.openSchedule);
    }
    if (typeof schedule?.scheduleEnabled === "boolean") {
      setScheduleEnabled(schedule.scheduleEnabled);
    }
  }, [schedule]);

  const handleAdd = () => {
    if (!dayOfWeek || !timeRange) {
      message.error("Выберите день и интервал времени");
      return;
    }

    const newItem = {
      dayOfWeek,
      startTime: timeRange[0].format("HH:mm"),
      endTime: timeRange[1].format("HH:mm"),
    };

    console.log("newItem", newItem)

    setSchedules((prev) => [...prev, newItem]);
    setDayOfWeek(undefined);
    setTimeRange(null);
  };

  const handleSave = async () => {
    try {
      await asiDeviceService.updateSchedule(asiId, {
        scheduleEnabled,
        openSchedule: schedules,
      });
      message.success("Расписание обновлено");
      window.location.reload();
    } catch (e) {
      console.error(e);
      message.error("Ошибка при обновлении расписания");
    }
  };

  const removeSchedule = (index: number) => {
    setSchedules(schedules.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginTop: 16, marginBottom: 16 }}>
      <Divider>Настройка расписания доступа</Divider>

      <Checkbox
        checked={scheduleEnabled}
        onChange={(e) => setScheduleEnabled(e.target.checked)}
      >
        Включить расписание
      </Checkbox>

      <Space wrap style={{ marginTop: 16 }}>
        <Select
          placeholder="День недели"
          value={dayOfWeek}
          onChange={setDayOfWeek}
          style={{ width: 180 }}
        >
          {DAYS.map((day) => (
            <Select.Option key={day.value} value={day.value}>
              {day.label}
            </Select.Option>
          ))}
        </Select>

        <TimePicker.RangePicker
          format="HH:mm"
          value={timeRange}
          onChange={setTimeRange}
          onOk={setTimeRange}
        />

        <Button type="primary" onClick={handleAdd}>
          Добавить
        </Button>
      </Space>

      <div style={{ marginTop: 16 }}>
        {schedules.map((item, index) => (
          <Space key={index} style={{ display: "flex", marginBottom: 8 }}>
            <span>
              {DAYS.find((d) => d.value === item.dayOfWeek)?.label ||
                item.dayOfWeek}
              : {item.startTime} — {item.endTime}
            </span>
            <Button danger size="small" onClick={() => removeSchedule(index)}>
              Удалить
            </Button>
          </Space>
        ))}
      </div>

      <Button type="primary" style={{ marginTop: 16 }} onClick={handleSave}>
        Сохранить расписание
      </Button>
    </div>
  );
};
